import React from "react";
import PropTypes from "prop-types";

import propTypes from "../IconCollectionDetailHero/propTypes";

import CreatorInfo from "./CreatorInfo";
import TooltipWithMessage from "core/TooltipWithMessage";

import {
    CollectionTitle,
    GeneralInfo,
    Cta,
    DownloadMessage,
    BuyBoxLayout,
    IconInfo,
    LicenseInfo
} from "./styles";

const Download = ({
    collectionName,
    creatorName,
    creatorCountry,
    creatorAvatarUrl,
    creatorProfilePath,
    totalIconCount,
    downloadUrl = "",
    isNewCreativeProSubscriber = false
}) => {
    return (
        <BuyBoxLayout>
            <CollectionTitle>{collectionName}</CollectionTitle>
            <CreatorInfo
                creatorName={creatorName}
                creatorCountry={creatorCountry}
                creatorAvatarUrl={creatorAvatarUrl}
                creatorProfilePath={creatorProfilePath}
            />
            <DownloadMessage>
                {isNewCreativeProSubscriber
                    ? "Thanks, Pro! Ready for download"
                    : "Ready for download"}
            </DownloadMessage>
            <GeneralInfo>
                <IconInfo>{totalIconCount} icons in PNG & SVG format</IconInfo>
                <LicenseInfo>
                    <TooltipWithMessage
                        text="Royalty-Free License"
                        toolTipText={
                            <>
                                No attribution required. For license info,{" "}
                                <a
                                    href="https://help.thenounproject.com/hc/en-us/articles/200509798-What-licenses-do-you-offer"
                                    target="_blank"
                                >
                                    see FAQ.
                                </a>
                            </>
                        }
                    />
                </LicenseInfo>
            </GeneralInfo>
            <Cta>Download Icon Set</Cta>
        </BuyBoxLayout>
    );
};

Download.propTypes = {
    ...propTypes,
    isNewCreativeProSubscriber: PropTypes.bool,
    creatorProfilePath: PropTypes.string.isRequired
};

export default Download;
